<template>
    <bottom-sheet v-model="shows" title="근로자 계약 생성하기" fullscreen persistent width="1224" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <form-tabs v-model="tab" v-slot="{ prev, next }">
                <!-- 기본입력 -->
                <tabs-create
                    v-model="form"
                    v-bind="{
                        tab,
                        shows,
                        loading,
                        applications,
                    }"
                    v-on="{
                        exit,
                        next,
                        save,
                    }"
                >
                    <form-applications v-model="applications" v-bind="{ items: applications }" list />
                </tabs-create>

                <!-- 공고선택 -->
                <tabs-select
                    v-model="applications"
                    v-bind="{
                        tab,
                        shows,
                    }"
                    v-on="{
                        prev,
                    }"
                />

                <!-- 인재검색 -->
                <tabs-search
                    v-model="applications"
                    v-bind="{
                        tab,
                        shows,
                    }"
                    v-on="{
                        prev,
                    }"
                />

                <!-- 완료화면 -->
                <tabs-finish v-bind="{ applications }" v-on="{ exit }" />
            </form-tabs>
        </v-layout>

        <v-fade-transition>
            <v-overlay v-show="loading" color="white">
                <v-progress-circular size="100" width="5" color="primary" :value="(completed.length / applications.length) * 100" />
            </v-overlay>
        </v-fade-transition>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { initEmploymentContract } from "@/assets/variables";
import { TABS } from "./form/lib";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";

import FormApplications from "./form/form-applications.vue";

import FormTabs from "./form/form-tabs.vue";
import TabsCreate from "./form/tabs/tabs-create.vue";
import TabsFinish from "./form/tabs/tabs-finish.vue";
import TabsSearch from "./form/tabs/tabs-search.vue";
import TabsSelect from "./form/tabs/tabs-select.vue";

export default {
    components: {
        BottomSheet,

        FormApplications,
        FormTabs,
        TabsCreate,
        TabsFinish,
        TabsSearch,
        TabsSelect,
    },
    props: {
        value: { type: Object, default: initEmploymentContract },
    },
    data: () => ({
        form: initEmploymentContract(),
        applications: [],
        completed: [],

        tab: TABS.CREATE.value,
        shows: false,
        loading: false,
    }),
    computed: {
        forms() {
            return this.applications.map(({ _id: _application, _applicant: _person }) => initEmploymentContract({ ...this.form, _person, _application }));
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        shows(shows) {
            if (shows) this.init();
        },
    },
    methods: {
        init() {
            this.form = initEmploymentContract();
            this.applications = [];
            this.completed = [];
            this.tab = TABS.CREATE.value;
        },

        exit() {
            this.shows = false;
        },

        validate() {
            try {
                if (!this.form.subject) throw new Error("계약명을 입력해주세요");
                if (!this.form._form) throw new Error("계약서를 선택해주세요");
                if (this.applications.length < 1) throw new Error("계약 대상자를 선택해주세요");

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },

        async save() {
            if (!this.validate()) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                await Promise.all([this.forms.map(async (form) => this.completed.push(await api.v1.company.employment.contracts.post(form)))]);

                this.tab = TABS.FINISH.value;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.row--x-small {
    margin: -4px;
}
.row--x-small > [class*="col"] {
    padding: 4px;
}
</style>
